import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import DesktopDevPageStage728x90 from '@wix/da-ads/pkg/adunits/DesktopDevPageStage728x90';
import { useDeviationViewContext } from '../../../Context';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../../Ads/redux/selectors';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useTranslation } from 'react-i18next';
import s from './StageContainer.scss';
export const StageContainer = ({ children , className  })=>{
    const { t  } = useTranslation();
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const { isTheater , isFullscreen  } = useDeviationViewContext();
    const showAd = useShouldRenderAdArea(adSafety);
    const isPrimis = useFlag('ads_primis_top');
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], showAd && s['with-ad'], className),
        "data-hook": BiDataHook.DEVIATION_ART_STAGE
    }, showAd && /*#__PURE__*/ React.createElement("div", {
        "aria-hidden": true,
        className: classnames(s['ad-slot'], isPrimis && s['primis'])
    }, /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90, {
        safety: adSafety
    }), isPrimis && /*#__PURE__*/ React.createElement("div", {
        className: s['primis-text']
    }, /*#__PURE__*/ React.createElement("h3", null, t('ads.video.popular.tuts.heading')), /*#__PURE__*/ React.createElement("p", null, t('ads.video.popular.tuts.subheading')), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
        href: t('ads.video.popular.tuts.one.link')
    }, t('ads.video.popular.tuts.one.text'))), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
        href: t('ads.video.popular.tuts.two.link')
    }, t('ads.video.popular.tuts.two.text'))), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
        href: t('ads.video.popular.tuts.three.link')
    }, t('ads.video.popular.tuts.three.text'))))), /*#__PURE__*/ React.createElement("div", {
        className: s['stage-content']
    }, children));
};
StageContainer.displayName = 'StageContainer';
export default StageContainer;
